import { render, staticRenderFns } from "./AcceptInvitationDialog.vue?vue&type=template&id=4fbde403&scoped=true&"
import script from "./AcceptInvitationDialog.vue?vue&type=script&lang=js&"
export * from "./AcceptInvitationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbde403",
  null
  
)

export default component.exports